import React from 'react';

import { Icon } from '@/components/memo';
import { addCircle } from 'ionicons/icons';

import './AddDentistTile.css';

interface AddDentistTileProps {
  onAddDentist: () => void;
  label: string;
}

const AddDentistTile: React.FC<AddDentistTileProps> = ({
  onAddDentist,
  label
}) => {
  return (
    <div className="add-dentist-tile" onClick={onAddDentist}>
      <Icon
        className="add-dentist-tile__icon"
        icon={addCircle}
        color="primary"
      />
      <p className="add-dentist-tile__label">{label}</p>
    </div>
  );
};

export default AddDentistTile;
